// setInterval that does nothing while the tab is in the background, and catches up the moment it comes back.
// Several pages polled the backend every 15–30 s from every open tab — including tabs nobody was looking at — which
// kept phones busy (battery, radio, memory) and added steady load to the API. Returns a function that stops it.
export function setVisibleInterval(fn, ms) {
  if (typeof document === "undefined") return () => {};
  let lastRun = Date.now();
  const run = () => { lastRun = Date.now(); fn(); };
  const iv = setInterval(() => { if (!document.hidden) run(); }, ms);
  const onVis = () => { if (!document.hidden && Date.now() - lastRun >= ms) run(); };
  document.addEventListener("visibilitychange", onVis);
  return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); };
}
